import { render, staticRenderFns } from "./VenteTonne.vue?vue&type=template&id=3963c9ac"
import script from "./VenteTonne.vue?vue&type=script&lang=js"
export * from "./VenteTonne.vue?vue&type=script&lang=js"
import style0 from "./VenteTonne.vue?vue&type=style&index=0&id=3963c9ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports